/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ prestige: NonNullable<unknown> }} Leveling_Ladder_PrestigeInputs */



/**
* | output |
* | --- |
* | "Prestige {prestige}" |
*
* @param {Leveling_Ladder_PrestigeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_ladder_prestige = /** @type {((inputs: Leveling_Ladder_PrestigeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Ladder_PrestigeInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Престиж ${i?.prestige}`)
	return /** @type {LocalizedString} */ (`Prestige ${i?.prestige}`)
});